module.exports = __webpack_public_path__ + "static/forms-cta-save-do-be52d1b32153d878952fa4ac56cbe6ae.png";